<div class="col-md-6">
    <div *ngIf="!logged" class="vanish-nav mx-auto "></div>
    <div *ngIf="!logged" class="nav d-flex flex-nowrap justify-content-center p-3 ">
        <div class="me-md-4 me-2 description-navbar my-auto" i18n> Crea il tuo profilo per accedere al servizio!
        </div>
        <button (click)="goTo()" class="my-auto me-md-1 ms-auto btn agos-button" i18n id="bottomNavbar-signin">
            Registrati
        </button>
    </div>
</div>